import { useContext } from "react";
import { CalendarBetaPropsContext } from "./CalendarBetaPropsContext";

export const useCalendarBetaProps = () => {
  return useContext(CalendarBetaPropsContext);
};
